module.exports = __webpack_public_path__ + "img/video-1-1.9a0e5605.jpeg";